export default __webpack_public_path__ + "static/media/orange-down-arrow.13de84c5.svg";